export class MongoAtlasRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "secretArn",
            "baseName": "secretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpRestoreAccountId",
            "baseName": "gcpRestoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureRestoreAccountId",
            "baseName": "azureRestoreAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
